import { useContext, useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { UserContext } from '../context/UserContext';
import Loader from '../components/Loader';
import LoginPageLink from './LoginPageLink';
import { readNextSignIn } from '../auth/runtimeAuth';
import { returnPathFromLocation } from '../auth/returnPath';
import './AuthStatusPage.scss';

// What /login shows while it sends the user straight to Microsoft's sign-in page
// (pages/Login.jsx decides when): a loader, or the reason the page could not be
// opened. Microsoft's page handles sign-in, account creation, password reset and
// MFA; the user comes back through /auth/callback, where errors from Microsoft
// land too. /login never renders this after a failed sign-in (`authError`), so
// it cannot bounce the user in a loop.
export default function MicrosoftSignin() {
  const { loginWithEntra } = useContext(UserContext);
  const location = useLocation();
  const [error, setError] = useState('');
  const started = useRef(false);

  const start = async () => {
    setError('');
    // After "sign in with another account" or a moved account's legacy session:
    // the same invitation and return path (auth/runtimeAuth nextSignIn).
    const next = readNextSignIn();
    try {
      await loginWithEntra({
        intent: next?.invitationToken ? 'invitation' : 'login',
        invitationToken: next?.invitationToken || null,
        // The page that sent the user to /login (ProtectedRoute, the "*" route).
        returnTo: next?.returnTo || returnPathFromLocation(location.state?.from),
      });
    } catch (startError) {
      console.error('Opening Microsoft sign-in failed:', startError);
      setError('לא הצלחנו לפתוח את דף ההתחברות. נסו שוב.');
    }
  };

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    start();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!error) return <Loader isLoading={true} />;

  return (
    <div className="auth-status-page" dir="rtl">
      <h1>כניסה למשלום</h1>
      <p role="alert">{error}</p>
      <button type="button" className="auth-status-primary" onClick={start}>נסו שוב</button>
      <LoginPageLink />
    </div>
  );
}
